import { api } from "@/lib/api";

const store = new Map();
const inflight = new Map();

const keyOf = (url, params) => {
  const q = params ? JSON.stringify(params) : "";
  return `${url}?${q}`;
};

/** Return cached data if present (sync). */
export function peekCache(url, params) {
  return store.get(keyOf(url, params));
}

/** Fetch with shared in-memory cache. Concurrent callers share one request. */
export function cachedGet(url, params) {
  const key = keyOf(url, params);
  if (store.has(key)) return Promise.resolve(store.get(key));
  if (inflight.has(key)) return inflight.get(key);

  const req = api
    .get(url, params ? { params } : undefined)
    .then(({ data }) => {
      store.set(key, data);
      inflight.delete(key);
      return data;
    })
    .catch((err) => {
      inflight.delete(key);
      throw err;
    });

  inflight.set(key, req);
  return req;
}

export function setCache(url, params, data) {
  store.set(keyOf(url, params), data);
}

export function clearCache(url, params) {
  if (url) store.delete(keyOf(url, params));
  else store.clear();
}

/** Warm common public endpoints so menus open with data ready. */
export function prefetchPublicData() {
  const jobs = [
    cachedGet("/products", { published: true }),
    cachedGet("/articles", { published: true }),
    cachedGet("/gallery"),
    cachedGet("/faqs", { published: true }),
    cachedGet("/testimonials", { published: true }),
    cachedGet("/careers", { published: true }),
    cachedGet("/lives", { published: true }),
    ...["about", "services", "products", "articles", "gallery", "faq", "contact"].map((k) =>
      cachedGet(`/pages/public-by-route/${k}`).catch(() => null)
    ),
  ];
  return Promise.allSettled(jobs);
}
